import { useSnackbar } from 'notistack';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogProps,
  DialogTitle,
} from '@mui/material';

import { Computer } from '@/types';
import { useDeleteComputerMutation } from '@/services';

export interface DeleteComputerProps extends DialogProps {
  computer: Computer;
  onClose(): void;
}

const DeleteComputer: React.FC<DeleteComputerProps> = ({ computer, onClose, ...props }) => {
  const { enqueueSnackbar } = useSnackbar();

  const [deleteComputer, deleteComputerResponse] = useDeleteComputerMutation();

  async function handleDeleteComputer() {
    try {
      await deleteComputer(computer).unwrap();

      onClose();
    } catch (error) {
      enqueueSnackbar(error.data, { variant: 'error' });
    }
  }

  return (
    <Dialog fullWidth {...props}>
      <DialogTitle fontWeight="bold">{computer?.code}</DialogTitle>

      <DialogContent dividers>
        <DialogContentText>Вы действительно хотите удалить "{computer?.code}"?</DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button
          color="secondary"
          variant="outlined"
          size="small"
          disabled={deleteComputerResponse.isLoading}
          onClick={onClose}
        >
          Закрыть
        </Button>

        <Button
          variant="contained"
          disabled={deleteComputerResponse.isLoading}
          size="small"
          onClick={handleDeleteComputer}
        >
          Да
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteComputer;
